<template>
  <div class="titleToolbar" @keydown.stop>
    <div class="left-grid">
      <el-tooltip
        effect="dark"
        content="快捷菜单"
        placement="bottom"
        :open-delay="1000"
      >
        <div class="hamburger-menu cursor" @click="openQuickManu">
          <div class="menu-icon"></div>
        </div>
      </el-tooltip>
      <!-- <a class="logo cursor" target="_blank" href="/templates">
        <img src="../../../../static/svg/laihua-logo-dark.png" alt="logo" />
      </a> -->
      <AppLogo style="margin-right: 13px;"></AppLogo>
      <input
        class="title"
        v-model="draftName"
        type="text"
        maxlength="32"
        @focus="editDraftNameFocus()"
        @blur="editDraftNameBlur()"
        @keydown.enter="editDraftName(false)"
      />
    </div>

    <!-- <div :style="{'color':'#474261','font-weight':'bold','font-size':'14px'}">添加字幕</div> -->

    <div class="right-grid">
      <div
        class="vipUpgrade cursor"
        @mouseenter.stop="toggleVipDropStatus(true)"
        @mouseleave.stop="toggleVipDropStatus(false)"
        v-if="UserLevel == 0 || 0 <= TmpLevelType"
      >
        <div class="button-layout">
          <div class="icon"></div>
          <span>会员升级</span>
        </div>

        <div class="vip-drop" v-show="vipDropStatus">
          <VipDrop></VipDrop>
        </div>
      </div>

      <div class="save">
        <div class="bg button-layout cursor" @click="saveDraft">
          <div class="icon" id="save-btn-icon"></div>
          <span v-show="WorksSaveState !== 'saving'" style="color: #5778fb">{{
            WorksSaveState === "saved" ? SaveDraftTime + "已保存" : "保存"
          }}</span>
          <span v-show="WorksSaveState === 'saving'" style="color: #5778fb">{{
            SaveDraftTime + "保存中"
          }}</span>
        </div>
      </div>

      <div
        class="complete-button cursor"
        :style="{ width: '112px' }"
        @click="onComplete"
      >
        返回画布
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VipDrop from "../../topnav/vipDrop";
import AppLogo from "../../topnav/appLogo.vue";

export default {
  name: "templateTitleToolbar",
  data() {
    return {
      vipDropStatus: false,
      draftName: "",
      backDraftName: "",
    };
  },
  props: {},
  components: { VipDrop, AppLogo },
  methods: {
    toggleVipDropStatus(val) {
      this.vipDropStatus = val;
      val &&
        sensors.track("doratoonGuideePopup", {
          popup_content: "常驻升级", // 弹窗引导内容
          restricted_function: "常驻升级", // 受限功能
          popup_category1: ["个人会员"], // 弹窗分类
        });
    },
    openQuickManu() {
      this.$bus.emit("showQuickMenu");
    },
    editDraftName() {
      this.$store.commit("save_WorksName", this.draftName);
    },
    editDraftNameFocus() {
      this.backDraftName = this.WorksName;
    },
    editDraftNameBlur() {
      if (!this.draftName) {
        this.draftName = this.backDraftName;
      } else {
        this.editDraftName();
      }
    },
    saveDraft() {
      this.$bus.emit("topnav.saveWorks");
    },
    onComplete() {
      this.$store.commit("subtitle/setSubIndex", -1);
      // if (!window.localStorage.getItem("close_quit_subtitle_tips")) {
      //   this.$modal.show("SubtitleMessageDialog", {
      //     view: "QuitSubtitleDialog",
      //     resultCallback: (value) => {
      //       if (value && value.type == "Ok") {
      //         this.closeSubtitleWindow();
      //       }
      //       if (value && value.noRemind) {
      //         window.localStorage.setItem("close_quit_subtitle_tips", "hide");
      //       }
      //     },
      //   });
      // } else {
      //   this.closeSubtitleWindow();
      // }

      this.closeSubtitleWindow();
    },
    closeSubtitleWindow() {
      // 将每个scenes播放时间回归
      for (let i = 0; i < this.TOOL.sprites.length; i++) {
        let scene = this.TOOL.sprites[i];
        let frame = Math.ceil(scene.nowTime * 60);
        // eve('playByFrame', null, frame, scene.id);
        this.TOOL.eve.emit("playByFrame", frame, scene.id);
        this.TOOL.eve.emit("play_" + scene.id, frame);
      }
      this.TOOL.cancelPlay();
      // 为了场景页播放
      this.subtitleEditor.setOption({
        width: this.TOOL.clientWidth,
        height: this.TOOL.clientHeight,
        rootId: "subtitle-player-9999",
      });
      //释放一些占内存的资源
      this.TOOL.sprites.forEach((scenes) => {
        if (scenes.id !== this.SelectScenes_Msg.id) {
          scenes.unActiveAnimation();
        }
      });

      // 播放后所有的scenes被隐藏，选择让其显示
      this.TOOL.selectScenes(this.SelectScenes_Msg);
      this.$bus.emit("topnav.saveWorks");
      this.$store.commit("subtitle/setOpenSubtitle", false);
      this.$store.commit("toggle_isPreventDefault", true);
    },
  },
  watch: {
    WorksName: function (newName) {
      this.draftName = newName;
    },
  },
  computed: {
    ...mapGetters([
      "TOOL",
      "SelectScenes_Msg",
      "UserLevel",
      "TmpLevelType",
      "WorksName",
      "SaveDraftTime",
      "WorksSaveState",
    ]),
    ...mapGetters({
      subtitleEditor: "subtitle/subtitleEditor",
    }),
  },
  created() {
    this.draftName = this.WorksName;
  },
  mounted() {
    this.$bus.off("backtoCanvas", this.onComplete);
    this.$bus.on("backtoCanvas", this.onComplete);
  },
  beforeDestroy() {
    this.$bus.off("backtoCanvas", this.onComplete);
  },
};
</script>

<style scoped lang='scss'>
@import "./commonStyle.scss";
.titleToolbar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 60px;
  background-color: #fff;
  box-shadow: 0px 0px 4px 0px rgba(44, 75, 248, 0.2);

  display: flex;
  align-items: center;
  // justify-content: space-between;
}

.left-grid {
  flex-grow: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 1px;
}
.right-grid {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  width: 1px;

  .save {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-right: 10px;
    .icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 10px;
      background-image: url(../../../../static/svg/save.svg);
      background-repeat: no-repeat;
    }
    .bg {
      height: 36px;
      border-radius: 4px;
    }
    &:hover {
      .bg {
        background: #fafaff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/titleToolbar/templateTitleToolbar.vue